import { EnvironmentMapLoader } from '@/infrastructure/engine3d/environment/EnvironmentMapLoader';
import { Color, NeutralToneMapping, type Scene, type Texture, type WebGLRenderer } from 'three';

// Sets NeutralToneMapping + grey background on init and preloads the
// default HDR envMap. Owned by strategies that need PBR reflections.
class EnvironmentController {
    private _backgroundColor: Color = new Color(0xf0f0f0);

    private _envMap: Promise<Texture> | null = null;

    initialize(scene: Scene, renderer: WebGLRenderer): void {
        renderer.toneMapping = NeutralToneMapping;
        renderer.toneMappingExposure = 0.95;
        scene.backgroundIntensity = 1.0;
        scene.backgroundBlurriness = 1.0;
        scene.background = this._backgroundColor;
        this._envMap = EnvironmentMapLoader.loadEquirectangular('/models/environmentMaps/venice_sunset_1k.hdr');
    }

    getEnvironmentMap(): Promise<Texture> | null {
        return this._envMap;
    }
}

export { EnvironmentController };
